<p-dialog [(visible)]="display" (onHide)="onDialogHide()" appendTo="body" [resizable]="false" [closable]="true">

  <p-header>
    <span>Enter Active Directory admin credentials</span>
  </p-header>

  <div style="width: 750px; margin-top: 10px; margin-bottom: 10px; margin-left: 10px;">
    @if (messageType === 'user') {
      <div>
        <p>
          Your Active Directory admin credentials are needed to retrieve user information from Active Directory.
        </p>
        <h4>The Information We Collect</h4>
        <p>
          UVexplorer Server retrieves a small amount of personal information from Active Directory, including:
        </p>
        <ol>
          <li>Active Directory user login names</li>
          <li>Active Directory user email addresses</li>
          <li>Active Directory user account identifiers</li>
        </ol>
        <h4>How We Use Your Information</h4>
        <p>
          Active Directory user account information is used to connect UVexplorer Server user accounts with their corresponding Active Directory user accounts.
        </p>
        <h4>How We Store Your Information</h4>
        <p>
          Collected Active Directory user account information is stored in UVexplorer Server's database.
          It is stored in an encrypted form so it cannot be read by someone who gains access to UVexplorer Server's database.
        </p>
        <h4>How We Share Your Information</h4>
        <p>
          We do not share your Active Directory information with anyone.
        </p>
      </div>
    }

    @if (messageType === 'group') {
      <div>
        <p>
          Your Active Directory admin credentials are needed to retrieve group information from Active Directory.
        </p>
        <h4>The Information We Collect</h4>
        <p>
          UVexplorer Server retrieves a small amount of group information from Active Directory, including:
        </p>
        <ol>
          <li>Active Directory group identifiers</li>
          <li>Active Directory group names</li>
          <li>Active Directory group member identifiers (users and groups)</li>
        </ol>
        <h4>How We Use Your Information</h4>
        <p>
          Active Directory user group information is used to connect UVexplorer Server user groups with their corresponding Active Directory user groups.
        </p>
        <h4>How We Store Your Information</h4>
        <p>
          Collected Active Directory user group information is stored in UVexplorer Server's database.
          It is stored in an encrypted form so it cannot be read by someone who gains access to UVexplorer Server's database.
        </p>
        <h4>How We Share Your Information</h4>
        <p>
          We do not share your Active Directory information with anyone.
        </p>
      </div>
    }

    <hr />

    <div style="margin-left: 60px;">
      <div class="auth-input">
        <label for="username">User Name</label><br />
        <input name="username" type="text" pInputText [(ngModel)]="username" />
      </div>

      <div class="auth-input">
        <label for="password">Password</label><br />
        <input name="password" type="password" pInputText [(ngModel)]="password" />
      </div>

      <div class="auth-input">
        <label for="domain">Domain Name</label><br />
        <select name="domain" style="padding: 3.75px;" [(ngModel)]="domain">
          @for (d of domains; track d) {
            <option value="{{d}}"
              [attr.selected]="(d == domain) ? '' : null">
              {{d}}
            </option>
          }
        </select>
      </div>
    </div>
  </div>

  <p-footer>
    <div style="margin-top: 10px; margin-bottom: 10px; text-align: center;">
      <button type="button" pButton class="ok-button" icon="fa fa-check" (click)="ok()" label="OK" [disabled]="!enableOk" autofocus></button>
      <button type="button" pButton class="cancel-button" icon="fa fa-close" (click)="cancel()" label="Cancel"></button>
    </div>
  </p-footer>

</p-dialog>
